import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from "react";
import activeSelectionReducer from "../Reducers/ActiveSelectionReducer";
import collectionReducer from "../Reducers/CollectionReducer";
import downloadReducer from "../Reducers/DownloadReducer";
import errorReducer from "../Reducers/ErrorReducer";
import filterReducer from "../Reducers/FilterReducer";
import mediaReducer from "../Reducers/MediaReducer";
import mediaSelectionReducer from "../Reducers/MediaSelectionReducer";
import pageReducer from "../Reducers/PageReducer";
import scopeReducer from "../Reducers/ScopeReducer";
import systemReducer from "../Reducers/SystemReducer";
import userReducer from "../Reducers/UserReducer";
// basic initialization values
import { defaultActiveSelection, defaultCollection, defaultError, defaultFilters, defaultPageParameters, defaultScope, defaultMedia, defaultMediaSelection, defaultUser, defaultDownload, defaultSystemConfig, } from "../types/dataModels";
var ReducerContext = createContext(null);
var DispatchContext = createContext(null);
export function useReducerContext() {
    var ctxValue = useContext(ReducerContext);
    if (ctxValue === null) {
        throw new Error("useReducerContext must not be null");
    }
    else {
        return ctxValue;
    }
}
export function useReducerDispatch() {
    var dispatchValue = useContext(DispatchContext);
    if (dispatchValue === null) {
        throw new Error("useReducerDispatch must not be null");
    }
    else {
        return dispatchValue;
    }
}
export function ReducerProvider(_a) {
    var children = _a.children;
    /* A global state context manager. */
    var _b = useReducer(activeSelectionReducer, defaultActiveSelection), activeSelection = _b[0], activeSelectionDispatch = _b[1];
    var _c = useReducer(collectionReducer, defaultCollection), collection = _c[0], collectionDispatch = _c[1];
    var _d = useReducer(downloadReducer, defaultDownload), download = _d[0], downloadDispatch = _d[1];
    var _e = useReducer(errorReducer, defaultError), error = _e[0], errorDispatch = _e[1];
    var _f = useReducer(filterReducer, defaultFilters), filter = _f[0], filterDispatch = _f[1];
    var _g = useReducer(scopeReducer, defaultScope), scope = _g[0], scopeDispatch = _g[1];
    var _h = useReducer(userReducer, defaultUser), user = _h[0], userDispatch = _h[1];
    var _j = useReducer(mediaReducer, defaultMedia), media = _j[0], mediaDispatch = _j[1];
    var _k = useReducer(mediaSelectionReducer, defaultMediaSelection), mediaSelection = _k[0], mediaSelectionDispatch = _k[1];
    var _l = useReducer(pageReducer, defaultPageParameters), page = _l[0], pageDispatch = _l[1];
    var _m = useReducer(systemReducer, defaultSystemConfig), system = _m[0], systemDispatch = _m[1];
    var items = {
        activeSelection: activeSelection,
        collection: collection,
        download: download,
        error: error,
        filter: filter,
        media: media,
        mediaSelection: mediaSelection,
        page: page,
        scope: scope,
        system: system,
        user: user,
    };
    var dispatches = {
        activeSelection: activeSelectionDispatch,
        collection: collectionDispatch,
        download: downloadDispatch,
        error: errorDispatch,
        filter: filterDispatch,
        media: mediaDispatch,
        mediaSelection: mediaSelectionDispatch,
        page: pageDispatch,
        scope: scopeDispatch,
        system: systemDispatch,
        user: userDispatch,
    };
    return (_jsx(ReducerContext.Provider, { value: items, children: _jsx(DispatchContext.Provider, { value: dispatches, children: children }) }));
}
